import { injectGlobal } from 'styled-components';

import normalize from './normalize';
import globals from './globals';

/* eslint-disable no-unused-expressions */
injectGlobal`
  ${normalize}
  ${globals}
`;



// WEBPACK FOOTER //
// ./src/styles/index.js